import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import "../parcel-tracking-modals.scss";
import { Col, Row } from "antd";
import { Button, SelectInput } from "@life-line-lab/components-react";

// A modal for setting handover points
// 11.09.2024 - currently used for
//                     -> delivery-management/sorting/bulk
//                     -> delivery-management/sorting/loose
//                     -> delivery-management/sorting/batches

interface SetHandoverPointModalProp {
  batchDetails?: { id: string; code: string };
  orders?: any[];
  handoverOptions: any[];
  onSubmit: (input: any) => void;
  handleCancel: () => void;
  setSelectedRows: React.Dispatch<React.SetStateAction<any[]>>;
}

const SetHandoverPointModal: React.FC<SetHandoverPointModalProp> = ({
  batchDetails,
  orders,
  handoverOptions,
  onSubmit,
  handleCancel,
  setSelectedRows,
}) => {
  const { t } = useTranslation();

  // handover point
  // -> only one can be selected
  const [selectedHandoverPoint, setSelectedHandoverPoint] = useState<any>("");

  const handleSelectChange = (value: string | string[], name: string) => {
    setSelectedHandoverPoint(value);
  };

  // call API
  // payload format
  // orderIDs: array["string"]
  // handoverPointID: string
  const handleSubmit = () => {
    const payload = orders
      ? {
          orderIDs: orders.map((order) => {
            return order._id;
          }),
          handoverPointID: selectedHandoverPoint,
        }
      : {
          batchParcelID: batchDetails?.id,
          handoverPointID: selectedHandoverPoint,
        };

    setSelectedRows && setSelectedRows([]);
    onSubmit(payload);
  };

  return (
    <Row gutter={[8, 8]}>
      <Col span={24}>
        <Row gutter={[8, 8]}>
          <Col>{t("action.setHandoverPoint")}</Col>
        </Row>
        <Row gutter={[8, 8]}>
          <Col span={24}>
            {t("txt.batchHandoverPoint")}
          </Col>
          <Col span={24}>
            <Row gutter={[0, 0]}  className="ptm-scrollable">
              {orders ? (
                orders?.map((order, index) => {
                  return (
                    <Col span={24} key={index}>
                      {order?.orderCode}
                    </Col>
                  );
                })
              ) : (
                <Col span={24}>{batchDetails?.code}</Col>
              )}
            </Row>
          </Col>
        </Row>
        <Row gutter={[0, 0]}>
          <Col span={24}>{t("label.selectHandoverPoint")}</Col>
          <Col span={24}>
            <SelectInput
              showSearch
              isRequired={true}
              onChange={(value: string | string[]) =>
                handleSelectChange(value, "handoverPoint")
              }
              options={handoverOptions?.map((place) => {
                return {
                  label: place.locationName || "",
                  value: place._id,
                };
              })}
              filterOption={(inputValue, option) =>
                option.label.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
              }
            />
          </Col>
        </Row>
        <Row gutter={[8, 8]}>
          <Col span={24}>
            <Button
              type={"primary"}
              label={t("action.confirm")}
              onClick={() => {
                handleSubmit();
              }}
            />
            <Button
              className="cancel-btn"
              type={"default"}
              label={t("action.cancel")}
              onClick={handleCancel}
            />
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default SetHandoverPointModal;
